/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { ApiCustomErrorCode } from 'client-code/action-details';

import { Locale } from '../locale/Locale';
import { LocaleKeys } from '../locale/LocaleKeys';
import { AppError } from './AppError';
import { ErrorTypes } from './ErrorTypes';

export class VodBrowseError extends AppError {
    public TAG: string = 'VodBrowseError';

    protected title: string = Locale.getString(LocaleKeys.VOD_BROWSE_ERROR_OVERLAY_TITLE);

    public constructor(code: string, message: string, description: string) {
        super(code, message);
        this.message = message;
        this.description = description;
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case ApiCustomErrorCode.ApigwError:
            case ApiCustomErrorCode.BadRequest:
            case ApiCustomErrorCode.DataNotFound:
            case ApiCustomErrorCode.DeviceInfoNotFound:
            case ApiCustomErrorCode.DynamoDbError:
            case ApiCustomErrorCode.InternalServerError:
            case ApiCustomErrorCode.PartnerInfoNotFound:
            case ApiCustomErrorCode.UnexpectedError:
                this.code = ErrorTypes.VOD_BROWSE_TECHNICAL_ERROR_V1400;
                break;
            default:
                this.code = ErrorTypes.VOD_BROWSE_TECHNICAL_ERROR_V1400;
        }
    }

    public getDescription(): string {
        return this.description;
    }

    public getTitle(): string {
        return this.title;
    }
}
